export const MEETING_HISTORY = "MEETING_HISTORY";
export const CREATE_MEETING = "CREATE_MEETING";
export const POC_LIST_DROPDOWN = "POC_LIST_DROPDOWN";
export const MEETING_BY_ID = "MEETING_BY_ID";
export const CANCEL_MEETING = "CANCEL_MEETING";
export const COMPLETE_MEETING = "COMPLETE_MEETING";



